import { brand } from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import svgBg from '@img/header-bg.svg?url';
import styled from 'styled-components';
const Container = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  grid-template-rows: 1fr;
  align-items: center;
  background: ${brand.white};
  background-image: url(${svgBg});
  background-repeat: no-repeat;
  filter: drop-shadow(0 4px 8px #00000029);
  height: var(--reducedHeaderHeight);
  width: 100%;
  z-index: ${Layers.Header};

  @media ${until(Device.Tablet)} {
    background-position: right -124px top -30px;
    background-size: 312px 220px;

        &.no-mobile-contact {
    --reducedHeaderHeight: 120px;
    }
    
  }

  @media ${from(Device.Tablet)} {
    background-position: ${(374 / 1920) * 100}vw -142px;
    display: flex;
  }
`;
const Inner = styled.div `
  ${siteWide};

  @media ${until(Device.Tablet)} {
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr;
    row-gap: 8px;
  }

  @media ${from(Device.Tablet)} {
    display: flex;
    align-items: center;
  }
`;
const LogoWrapper = styled.a `
  display: block;
  color: currentColor;
  outline: none;

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }

  @media ${until(Device.Tablet)} {
    grid-column: 1;
    grid-row: 1;
  }
`;
const Logo = styled.img `
  display: block;
  object-fit: contain;
  object-position: center left;

  @media ${until(Device.Tablet)} {
    height: 48px;
    width: 96px;
  }

  @media ${from(Device.Tablet)} {
    height: 72px;
    width: 145px;
  }
`;
const ContactWrapper = styled.div `
  @media ${until(Device.Tablet)} {
    display: none
  }

  @media ${from(Device.Tablet)} {
    margin-left: auto;
  }
`;
const MobileContactWrapper = styled.div `
  @media ${from(Device.Tablet)} {
    display: none;
  }

  border-top: 0.1875rem solid #D9E9AD;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${brand.white};
  align-self: end;

`;
const CtaWrapper = styled.div `
  @media ${until(Device.Tablet)} {
    grid-column: 2;
    grid-row: 1;
    justify-self: flex-end;
  }

  @media ${from(Device.Tablet)} {
    margin-left: 24px;
  }

  @media ${from(Device.DesktopSmall)} {
    margin-left: 56px;
  }
`;
const RightWrapper = styled.div `
  margin-left: auto;
  display: flex;
`;
const HeaderReducedStyles = {
    ContactWrapper,
    MobileContactWrapper,
    Container,
    CtaWrapper,
    Inner,
    Logo,
    LogoWrapper,
    RightWrapper,
};
export default HeaderReducedStyles;
